module.exports = __webpack_public_path__ + "media/images/forms-icons/text-area-icon-hover-882f820255bce90ff1c04c99fd7b97e8.svg";